import { useLayoutEffect } from "react";

/**
 * Marks which page is showing so the header, tabs and dashboard card can be
 * painted as one gradient block (see the `dash-*` rules in theme.css).
 *
 * Deliberately does no measuring: an earlier version sized a floating layer to
 * the card, which visibly resized whenever content above the card appeared or
 * collapsed while the page loaded.
 */
const DashboardCanvas = ({ theme }) => {
  useLayoutEffect(() => {
    const className = `dash-${theme}`;
    document.body.classList.add("dash-hero", className);
    return () => {
      document.body.classList.remove("dash-hero", className);
    };
  }, [theme]);

  return null;
};

export default DashboardCanvas;
